import React, { useState, useEffect } from "react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { Container, ContainerPaginate,ContainerInput } from "./styles";
import { Link, withRouter } from "react-router-dom";
import Loading from "../../../components/Loading";
import { Pagination } from "semantic-ui-react";
import { TableContainer, TableHead, TableRow, Paper, TableCell, TableBody, Table, Input } from '@material-ui/core';
import { producaov2 as api } from "../../../services/apis";
import { smallDateFormat } from "../../../utils/Utils";
import { FaInstagramSquare, FaWindowClose, FaLinkedin } from 'react-icons/fa';
import ModalCreateParceiro from "../../../components/Admin/Modal/ModalCreateParceiro";

const Parceiros = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [open, setOpen] = useState(false);

  async function getData() {
    setLoading(false);
    await api.get(`/admin/parcerias/listar?page=${page}${search && "&search=" + search}`)
      .then(res => {
        setData(res.data.rows);
        setTotal(res.data.count);
        setLoading(true);
      })
      .catch(err => {
        console.log("ERROR: ===>>>> ", err)
      })
  }

  useEffect(() => {
    getData();
  }, []);


  // "id": 71,
  // "nome": "Luiz Henrique Rodrigues Cabral",
  // "email": "luiz_henrique320@hotmail.com",
  // "telefone": "(11)98268-2011",
  // "linkedin": "null",
  // "instagram": "null",
  // "nome_instituicao": "null",
  // "modelo_parceria": "null",
  // "publico": 0,
  // "tema": "null",
  // "tipo": 1,
  // "ativo": null,
  // "categoria": "0",
  // "data_sys": "2024-04-11T18:13:49.000Z"


  const getType = (type) => {

    const is = {
      1: "Afiliado",
      2: "Embaixador",
      3: "instrutor",
      4: "Instituição",
      5: "Evento",
      6: "Conteúdo",
      7: "ME"
    }[type];

    return is;
  };

  const getLinkedinUrl = (url) => {
    if (!url || url == "null") {
      return "#"
    }
    if (url.includes("linkedin.com")) {
      return url;
    }
    return `https://www.linkedin.com/in/${url}`
  };
  const getInstaUrl = (url) => {
    if (!url || url == "null") {
      return "#"
    }
    if (url.includes("instagram.com")) {
      return url;
    }
    return `https://www.instagram.com/${url}`
  };


  if (!loading) {
    <Loading msg="Buscando dados" />
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <ContainerInput>
          <Input
          placeholder="Procure pelo email ou nome"
          onChange={e => setSearch(e.target.value)}
          style={{width: "100%"}}
          />
          <button onClick={() => getData()}>Buscar</button>
          <button onClick={() => setOpen(true)}>Criar</button>
        </ContainerInput>
        {
          data && data.length ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead style={{ position: "sticky", top: 0 }}>
                  <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                    <TableCell align="left">Nome</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Phone</TableCell>
                    <TableCell align="left">Instagram</TableCell>
                    <TableCell align="left">Linkedin</TableCell>
                    <TableCell align="left">Público</TableCell>
                    <TableCell align="center">Instituição</TableCell>
                    <TableCell align="center">Modelo</TableCell>
                    <TableCell align="center">Tema</TableCell>
                    <TableCell align="center">Tipo</TableCell>
                    <TableCell align="center">Categoria</TableCell>
                    <TableCell align="center">Cadastro</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    data
                      .filter(item => search ? item.email.includes(search) || item.nome.includes(search) : item )
                      .map((row, index) => (
                        <TableRow
                          hover
                          key={index}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell >
                            {row.nome}
                          </TableCell>
                          <TableCell >
                            {row.email}
                          </TableCell>
                          <TableCell align="left">{row.telefone}</TableCell>
                          <TableCell align="left" hover component={"a"} style={{ cursor: "pointer" }} target="_blank" href={getInstaUrl(row.instagram)}>{row.instagram && row.instagram != "null"? <FaInstagramSquare size={20}  color=" #c13584"/> : <FaWindowClose size={18} color="red"/>}</TableCell>
                          <TableCell align="left" hover component={"a"} style={{ cursor: "pointer" }} target="_blank" href={getLinkedinUrl(row.linkedin)}>{row.linkedin && row.linkedin != "null" ? <FaLinkedin size={20} color="#0e76a8" /> : <FaWindowClose size={18} color="red"/>}</TableCell>
                          <TableCell align="left">{row.publico || "-"}</TableCell>
                          <TableCell align="left">{row.nome_instituicao && row.nome_instituicao != "null" ? row.nome_instituicao : "-"}</TableCell>
                          <TableCell align="left">{row.modelo || "-"}</TableCell>
                          <TableCell align="left">{row.tema && row.tema != "null" ? row.tema : "-"}</TableCell>
                          <TableCell align="left">{getType(row.tipo)}</TableCell>
                          <TableCell align="left">{row.categoria || "-"}</TableCell>
                          <TableCell align="left">{smallDateFormat(row.data_sys)}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : <></>
        }

        {data && data.length ? (
          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={parseInt(total / 30)}
              onPageChange={(e, f) => setPage(f.activePage)}
              page={page}
            />
          </ContainerPaginate>

        ) : <></>}
      <ModalCreateParceiro open={open} handleClose={setOpen} change={getData} />
      </Container>

    </div>
  );
};


export default withRouter(Parceiros);
